import type { PageContentItem } from '../models/page';

const spliceHeaderFromContentItems = (
  items: readonly PageContentItem[]
): { items: PageContentItem[]; header?: PageContentItem } => {
  const headerItemIdx = items.findIndex(
    (item) =>
      item.componentName === 'header' || item.componentName === 'job-header'
  );

  const itemsCopy = [...items];
  const header =
    headerItemIdx !== -1 ? itemsCopy.splice(headerItemIdx, 1)[0] : undefined;

  return {
    items: itemsCopy,
    header,
  };
};

export default spliceHeaderFromContentItems;
